<template>
  <div class="hexagrams-container">
    <h1 class="hexagrams-title">64괘상(卦像) 공부</h1>
    <p>
      64괘상은 주역의 핵심으로, 각 괘는 인생의 다양한 상황과 원리를 상징합니다.
      아래에서 각 괘를 클릭하여 자세한 내용을 확인하세요.
    </p>
    <!-- 상경 (1~30) -->
    <h2 class="card-title">상경(上經)</h2>
    <section class="card">
      <ul class="list">
        <li
          v-for="item in upper"
          :key="item.index"
          class="list-item"
        >
          <button class="row" @click="goDetail(item.name_ko)">
            <span class="title">{{ item.name_ko }} ({{ item.name_zh }})</span>
            <span aria-hidden="true" class="chevron">›</span>
          </button>
        </li>
      </ul>
    </section>

    <!-- 하경 (31~64) -->
    <h2 class="card-title">하경(下經)</h2>
    <section class="card">
      <ul class="list">
        <li
          v-for="item in lower"
          :key="item.index"
          class="list-item"
        >
          <button class="row" @click="goDetail(item.name_ko)">
            <span class="title">{{ item.name_ko }} ({{ item.name_zh }})</span>
            <span aria-hidden="true" class="chevron">›</span>
          </button>
        </li>
      </ul>
    </section>

    <div class="button-area">
      <button @click="goBack">돌아가기</button>
    </div>
  </div>
</template>

<script>
import { fullHexagrams } from '@/data/fullHexagrams.js'

export default {
  name: 'HexagramIndex',
  data() {
    return {
      // 상경: 앞 30개, 하경: 나머지 34개
      upper: fullHexagrams.slice(0, 30),
      lower: fullHexagrams.slice(30),
    }
  },
  methods: {
    goDetail(name) {
      this.$router.push({ name: 'HexagramDetail', params: { name } })
      console.log(name)
    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.hexagrams-container {
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: var(--device-width);
  max-width: 480px;
  margin: auto;
  box-sizing: border-box;
}

.hexagrams-container p {
  font-size: var(--font-size-10);
  line-height: 1.6;
  color: gray; /* Adjusted color */
  margin-bottom: 2rem; /* Added margin-bottom */
  text-align: center; /* Centered text */
}

.hexagrams-title {
  font-size: var(--font-size-14);
  text-align: center;
  margin-top: 0.5rem;
  font-weight: bold;
  margin-bottom: 0.1rem; /* Added margin-bottom */
}

.card-title {
  font-size: var(--font-size-12);
  margin-top: 0; /* Adjusted margin */
  margin-bottom: 0.8rem; /* Added margin-bottom */
  color: #333; /* Adjusted color */
  text-align: center;
}

.card {
  margin-bottom: 1.5rem; /* Added margin-bottom */
  padding: 1rem;
  border: 1px solid #eee; /* Added border */
  border-radius: 8px; /* Added border-radius */
  background-color: #f9f9f9; /* Added background-color */
}

.card p {
  font-size: var(--font-size-10);
  line-height: 1.6;
  white-space: pre-wrap; /* Preserve line breaks */
  word-break: break-word; /* Break long words */
  color: #555; /* Adjusted color */
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.list-item + .list-item {
  border-top: 1px solid #f0f0f0;
}
.row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-size: var(--font-size-10);
  line-height: 1.6;
  white-space: pre-wrap; /* Preserve line breaks */
  word-break: break-word; /* Break long words */
  color: #555; /* Adjusted color */
}
.row:hover { background: #fafafa; }
  
.button-area {
  margin-top: auto; /* Push button to the bottom */
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.button-area button {
  padding: 0.7rem 1.5rem;
  font-size: var(--font-size-10);
  border: none;
  border-radius: 8px;
  background-color: #f44336;
  color: white;
  cursor: pointer;
}

.button-area button:hover {
  background-color: #da190b;
}
</style>
